import { useEffect, useRef, useState } from 'react';

type MiniPlayerScrollingTitleProps = {
  text: string;
};

/** 제목이 잘리면 왼쪽으로 천천히 흐르는 마키 */
export function MiniPlayerScrollingTitle({ text }: MiniPlayerScrollingTitleProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const measureRef = useRef<HTMLSpanElement>(null);
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    const container = containerRef.current;
    const measure = measureRef.current;
    if (!container || !measure) return;

    const check = () => {
      setScroll(measure.scrollWidth > container.clientWidth + 1);
    };

    check();
    const ro = new ResizeObserver(check);
    ro.observe(container);
    return () => ro.disconnect();
  }, [text]);

  return (
    <div ref={containerRef} className="relative min-w-0 overflow-hidden w-full">
      <span
        ref={measureRef}
        aria-hidden
        className="pointer-events-none absolute opacity-0 whitespace-nowrap font-headline text-sm font-semibold"
      >
        {text}
      </span>
      {scroll ? (
        <div className="soundpill-mini-player-title-marquee flex w-max">
          <span className="font-headline text-sm font-semibold text-white whitespace-nowrap pr-10">{text}</span>
          <span aria-hidden className="font-headline text-sm font-semibold text-white whitespace-nowrap pr-10">
            {text}
          </span>
        </div>
      ) : (
        <span className="font-headline text-sm font-semibold text-white truncate block">{text}</span>
      )}
    </div>
  );
}
